import { render, staticRenderFns } from "./InstagramImage.vue?vue&type=template&id=cd648cc0&scoped=true"
import script from "./InstagramImage.vue?vue&type=script&lang=js"
export * from "./InstagramImage.vue?vue&type=script&lang=js"
import style0 from "./InstagramImage.vue?vue&type=style&index=0&id=cd648cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd648cc0",
  null
  
)

export default component.exports